export default __webpack_public_path__ + "static/media/bloodlevel@2x.fe32d28f.jpg";